import { Swiper } from 'swiper/bundle'

const partnersSlider = new Swiper('.carousel', {
	spaceBetween: 96,
	loop: true,
	speed: 2600,
	autoplay: {
		delay: 0,
		pauseOnMouseEnter: true
	},
	slidesPerView: 2,
	breakpoints: {
		640: {
			slidesPerView: 3
		},
		768: {
			slidesPerView: 4
		},
		1024: {
			slidesPerView: 5
		}
	}
})
